<script>
import CardList from "@/views/solicitudes/components/CardList.vue";
import TablaTabs from "@/views/solicitudes/components/TablaTabs.vue";
import { mapMutations, mapState } from "vuex";

export default {
  name: "Capacidades",
  components: { TablaTabs, CardList },
  props: {
    rol: {
      type: String,
      required: true,
      default: () => "unidad"
    },
    idSoli: {
      type: Number,
      default: () => 7
    },
    isView: {
      type: Boolean
    }
  },
  data() {
    return {
      paginacionOA: {
        pagina: 1,
        por_pagina: 10,
        total_registro: 0
      },
      paginacionCA: {
        pagina: 1,
        por_pagina: 10,
        total_registro: 0
      },
      listMenu: [
        {
          id: 1,
          name: "Capacidades",
          icon: "mdi-wrench-outline",
          tag: "capacidades"
        },
        {
          id: 2,
          name: "Otros aspectos",
          icon: "mdi-clipboard-search-outline",
          tag: "otros_aspectos"
        }
      ],
      headersCapacidades: [
        {
          text: "Mostrar en oferta",
          value: "activo",
          class: "black--text py-2 font-weight-bold text-subtitle-1",
          align: "left",
          width: "180px",
          sortable: false
        },
        {
          text: "N°",
          value: "correlativo",
          class: "black--text py-2 font-weight-bold text-subtitle-1",
          align: "left",
          width: "120px",
          sortable: false
        },
        {
          text: "Descripción de actividad",
          value: "nombre",
          class: "black--text py-2 font-weight-bold text-subtitle-1",
          align: "left",
          sortable: false
        }
      ],
      itemsCapacidades: [],
      headersOtrosAspectos: [
        {
          text: "Mostrar en oferta",
          value: "activo",
          class: "black--text py-2 font-weight-bold text-subtitle-1 ",
          align: "left",
          width: "180px",
          sortable: false
        },
        {
          text: "N°",
          value: "correlativo",
          class: "black--text py-2 font-weight-bold text-subtitle-1",
          align: "left",
          width: "120px",
          sortable: false
        },
        {
          text: "Nombre",
          value: "nombre_aspecto",
          class: "black--text py-2 font-weight-bold text-subtitle-1 otros",
          align: "left",
          sortable: false
        }
      ],
      itemsOtrosAspectos: [],
      id: 7
    };
  },
  methods: {
    ...mapMutations("utils", ["setLoader"]),
    async getOtrosAspectos() {
      this.setLoader(true);
      let params = {
        cantidad_por_pagina: this.paginacionOA.por_pagina,
        pagina: this.paginacionOA.pagina
      };
      const { data } = await this.services.catalogos.getCatalogo(
        `otros_aspectos/${this.idSoli}`,
        params
      );
      if (Array.isArray(data.data)) {
        this.itemsOtrosAspectos = data.data.map((x, index) => {
          x.correlativo = index + 1;
          return x;
        });
      } else {
        this.itemsOtrosAspectos = [];
      }
      this.$nextTick(() => {
        this.paginacionOA.pagina = Number(data.meta.pagina);
        this.paginacionOA.por_pagina = Number(data.meta.cantidad_por_pagina);
        this.paginacionOA.total_registro = Number(data.meta.total);
      });
      for (let i = 0; i < this.itemsOtrosAspectos.length; i++) {
        this.$set(this.itemsOtrosAspectos[i], "activo", false);
      }
      this.setLoader(false);
      this.getOtrosAspectosAsignados();
    },
    async getCapacidades() {
      this.setLoader(true);
      let params = {
        cantidad_por_pagina: this.paginacionCA.por_pagina,
        pagina: this.paginacionCA.pagina
      };
      const { data } = await this.services.catalogos.getCatalogo(
        `capacidades/${this.idSoli}`,
        params
      );
      if (Array.isArray(data.data)) {
        this.itemsCapacidades = data.data.map((x, index) => {
          x.correlativo = index + 1;
          return x;
        });
      } else {
        this.itemsCapacidades = [];
      }
      this.$nextTick(() => {
        this.paginacionCA.pagina = Number(data.meta.pagina);
        this.paginacionCA.por_pagina = Number(data.meta.cantidad_por_pagina);
        this.paginacionCA.total_registro = Number(data.meta.total);
      });
      for (let i = 0; i < this.itemsCapacidades.length; i++) {
        this.$set(this.itemsCapacidades[i], "activo", false);
      }
      this.setLoader(false);
      this.getCapacidadesAsignadas();
    },
      async setPerPageCapacidades(perPage) {
        this.paginacionCA.por_pagina = perPage;
        this.paginacionCA.pagina = 1;
        await this.getCapacidades();
      },
    async getOtrosAspectosAsignados() {
      const response = await this.services.catalogos.getOtrosAspectosAsig(
        this.$route.params.id
      );
      let idArreglo = response.data.ids;
      for (let i = 0; i < this.itemsOtrosAspectos.length; i++) {
        const objeto = this.itemsOtrosAspectos[i];
        if (idArreglo.includes(objeto.id)) {
          this.$set(objeto, "activo", true);
        }
      }
      if (!this.fasesUnidad.includes(this.faseActual)) {
        this.itemsOtrosAspectos = this.itemsOtrosAspectos.filter(item => item.activo);
      }
    },
      async setPerPageOtrosAspectos(perPage) {
        this.paginacionOA.por_pagina = perPage;
        this.paginacionOA.pagina = 1;
        await this.getOtrosAspectos();
      },
    async getCapacidadesAsignadas() {
      const response = await this.services.catalogos.getCapacidadAsig(
        this.$route.params.id
      );
      let idArreglo = response.data.ids;
      for (let i = 0; i < this.itemsCapacidades.length; i++) {
        const objeto = this.itemsCapacidades[i];
        if (idArreglo.includes(objeto.id)) {
          this.$set(objeto, "activo", true);
        }
      }
      if (!this.fasesUnidad.includes(this.faseActual)) {
        this.itemsCapacidades = this.itemsCapacidades.filter(item => item.activo);
      }
    },
    async setPaginacionOtrosAspectos(pagina) {
      this.paginacionOA.pagina = pagina;
      await this.getOtrosAspectos();
    },
    async setPaginacionCapacidades(pagina) {
      this.paginacionCA.pagina = pagina;
      await this.getCapacidades();
    },
    async inputChange(event, item, tipo) {
      this.setLoader(true);

      // Bloquear cambios si no está en fase editable o está en modo vista
      if (!this.enFaseRRHH && !this.enFaseUnidad) {
        this.setLoader(false);
        return;
      }

      if (tipo === "capacidades") {
        let body = {
          id_solicitud: Number(this.$route.params.id),
          id_catalogo: item.id
        };
        const response = await this.services.catalogos.postCatalogo(
          "capacidades",
          body
        );
        if (response.status === 200 || response.status === 201) {
          this.getCapacidadesAsignadas();
        }
      } else if (tipo === "otros_aspectos") {
        let body = {
          id_solicitud: Number(this.$route.params.id),
          id_catalogo: item.id
        };
        const response = await this.services.catalogos.postCatalogo(
          "aspectos",
          body
        );
        if (response.status === 200 || response.status === 201) {
          this.getOtrosAspectosAsignados();
        }
      }
      this.setLoader(false);
    },
    async init() {
      await Promise.race([this.getOtrosAspectos(), this.getCapacidades()]);
    }
  },
  async created() {
    await this.init();
  },
  computed: {
    ...mapState("solicitud", [
      "solicitud",
      "faseActual",
      "esFaseActivaUsuario",
      "fasesRh",
      "fasesUnidad"
    ]),
    enFaseRRHH() {
      return this.fasesRh.includes(this.faseActual);
    },
    enFaseUnidad() {
      const cumpleFaseUnidad = this.fasesUnidad.includes(this.faseActual);
      
      const rutaAprobacion = this.$route.name.includes("aprobacion-solicitud");
      const idObservado = 6;
      const observado = this.solicitud.estado_fase_solicitud.id === idObservado;
      if(observado){
        return cumpleFaseUnidad && observado && !rutaAprobacion;
      }
      return cumpleFaseUnidad;
    },
    enVistaDetalle(){
      const rutaVer = this.$route.name.includes("solicitud-view");
      return rutaVer;
    }
  }
};
</script>

<template>
  <div>
  <v-row>
    <v-col cols="12">
      <v-row class="justify-end" v-if="rol === 'despacho' || rol === 'ufi'">
        <v-col cols="12" sm="5">
          <v-autocomplete label="Estado" outlined class="rounded-xl" dense>
          </v-autocomplete>
        </v-col>
      </v-row>
      <p class="text-h5 font-weight-bold primary--text" ref="capacidades">
        Capacidades
      </p>
      <v-row>
        <v-col class="px-sm-3 px-1">
          <div class="my-6 pa-sm-4">
            <tabla-tabs
              :key-id="'id'"
              :data="itemsCapacidades"
              :headers="headersCapacidades"
              :por_pagina="paginacionCA.por_pagina"
              :page="paginacionCA.pagina"
              :total-registros="paginacionCA.total_registro"
              :slots-column="['activo']"
              @paginationChange="setPaginacionCapacidades"
              @perPageChange="setPerPageCapacidades"
              :rol="rol"
              nombre-pagina="pca"
            >
              <template #[`activo`]="{ item }">
                <div class="d-flex align-center justify-center">
                  <v-checkbox
                    class="d-flex justify-center"
                    color="primary"
                    v-model="item.activo"
                    @change="inputChange($event, item, 'capacidades')"
                    :readonly="!enFaseUnidad || enVistaDetalle"
                    :disabled="!enFaseUnidad || enVistaDetalle"
                  ></v-checkbox>
                </div>
              </template>
            </tabla-tabs>
          </div>
        </v-col>
      </v-row>
      <p class="text-h5 font-weight-bold primary--text" ref="otros_aspectos">
        Otros aspectos
      </p>
      <v-row>
        <v-col class="px-sm-3 px-1">
          <div class="my-6 pa-sm-4">
            <tabla-tabs
              :key-id="'id'"
              :data="itemsOtrosAspectos"
              :headers="headersOtrosAspectos"
              :por_pagina="paginacionOA.por_pagina"
              :page="paginacionOA.pagina"
              :total-registros="paginacionOA.total_registro"
              :slots-column="['activo']"
              @paginationChange="setPaginacionOtrosAspectos"
              @perPageChange="setPerPageOtrosAspectos"
              :rol="rol"
              nombre-pagina="poa"
            >
              <template #[`activo`]="{ item }">
                <div class="d-flex align-center justify-center">
                  <v-checkbox
                    class="d-flex justify-center"
                    color="primary"
                    v-model="item.activo"
                    @change="inputChange($event, item, 'otros_aspectos')"
                    :readonly="!enFaseUnidad || enVistaDetalle"
                    :disabled="!enFaseUnidad || enVistaDetalle"
                  ></v-checkbox>
                </div>
              </template>
            </tabla-tabs>
          </div>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
  </div>
</template>

<style scoped lang="scss">
.otros {
  width: 900px;
}
</style>
